import { jsx as t } from "react/jsx-runtime";

import { useCallback as s } from "react";

import { useSyncExternalStore as e } from "use-sync-external-store/shim";

import o from "../hooks/useGlobals.js";

import { findDayNot as r } from "../utils/index.js";

import n from "../../../utils/classNames/index.js";

const i = ({fn: i, step: m, limitFn: a, ...l}) => {
    const {model: d} = o(), u = s((() => {
        const t = i(d.intendedTs, m);
        return r(t, a(t), d.isDateDisabled, m);
    }), []), p = e(d.on, u, u), b = void 0 === p;
    return t("button", {
        ...l,
        disabled: b,
        type: "button",
        className: n("px-s py-xs btn-unsized btn-neutral-borderless", b && "!bg-transparent !text-neutral-400"),
        onClick: b ? void 0 : () => d.intend(p)
    });
};

export { i as default };
//# sourceMappingURL=MonthYearNavigationButton.js.map
